import { Frame } from '../../../types/types';

export const getFrameTextVAlign = (frameText: Frame) => {
  if (frameText.text?.valign === 'top') return 'start';
  if (frameText.text?.valign === 'bottom') return 'end';
  return 'center';
};
